'use client';

import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import type { ElasticBranch } from '@//app/api/search/branch/[id]';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { Button } from '@//components/Button';
import { useLegacyTrackLinkClickToDealerPage } from '@//data/tracking/useLegacyTrackLinkClickToDealerPage';

interface LinkToSellerPageProps {
  branch: ElasticBranch;
  vehicle: ElasticVehicle;
  retailersPage: string;
}

const LinkToSellerPage = ({ branch, vehicle, retailersPage }: LinkToSellerPageProps) => {
  const t = useTranslations('pages.item.sellerSection.retailerPageLink');
  const { trackLegacyLinkClickToDealerPage } = useLegacyTrackLinkClickToDealerPage();

  const onClick = useCallback(
    () => trackLegacyLinkClickToDealerPage(vehicle),
    [trackLegacyLinkClickToDealerPage, vehicle],
  );

  return (
    <Button
      size="lg"
      variant="primary"
      fullWidth
      href={`${retailersPage}/${branch.slug}`}
      title={t('title')}
      onClick={onClick}
      prefetch="viewport"
    >
      {t('label')}
    </Button>
  );
};

export default LinkToSellerPage;
